import { getSortMetrics } from './getSortMetrics';
import { getWidthMetrics } from './getWidthMetrics';
import type { Chart } from './types';

export const getRequestedMetrics = (config: Chart): string[] => {
  return [
    ...new Set(
      [
        config.primaryMetric,
        config.secondaryMetric,
        ...getWidthMetrics(config),
        ...getSortMetrics(config),
      ].filter(Boolean),
    ),
  ];
};
